// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3406":"6cfd1dff","3803":"6cfd1dff"}[chunkId] + ".chunk.css";
};